<template>
  <div class="flex flex-col">
    <div
      class="flex flex-wrap gap-x-2 gap-y-3 sm:flex-nowrap"
      :class="{ 'flex-col': !horizontal }"
    >
      <select
        :id="`appointment_options-${store.id}`"
        v-model="appointmentOption"
        class="flex-none rounded default:border-secondary-700 hover:border-black focus:border-secondary-700 focus:outline-none"
        :class="{
          'w-[256px] sm:w-[calc(50%-0.25rem)]': horizontal,
          'text-neutral-50': !appointmentOption,
        }"
        @click.stop
      >
        <option value="" disabled>
          {{ $t('store_finder.search.choose_option') }}
        </option>
        <option
          v-for="(title, i) in STORE_SERVICE_TYPES.filter((j) =>
            appointmentType.includes(j),
          ).map((k) => ({
            value: k,
            name: $t(`store_finder.search.options.${k}`),
          }))"
          :key="i"
          :value="title.value"
        >
          {{ title.name }}
        </option>
      </select>

      <FimButton
        v-if="!appointmentOption"
        key="button-button"
        is-small
        class="!pointer-events-auto"
        :class="{ 'w-[256px] sm:w-[calc(50%-0.25rem)]': horizontal }"
        data-testid="ndl_search_button_book"
        :disabled="true"
      >
        <template #icon>
          <LazyIconFielmannCalendar class="size-6" />
        </template>
        {{ $t('store_finder.title') }}
      </FimButton>
      <FimButton
        v-else
        :id="`store-${store.id}`"
        key="link-button"
        rel="nofollow"
        is-small
        :class="{ 'w-[256px] md:w-1/2': horizontal }"
        data-testid="ndl_search_button_book"
        :to="appointmentLink"
        @click.stop="onCTAClick"
      >
        <template #icon>
          <LazyIconFielmannCalendar class="size-6" />
        </template>
        {{ $t('store_finder.title') }}
      </FimButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useStores } from '~/composables/useStores'
import type { IStore } from '~/rpcMethods/stores'
import FimButton from '~/components/ui/buttons/FimButton.vue'
// import { useLogging } from '~/composables/useLogging'

const props = defineProps({
  store: {
    type: Object as PropType<IStore>,
    required: true,
  },
  horizontal: {
    type: Boolean,
    default: false,
  },
})

const $currentShop = useCurrentShop()
const { searchOption } = useStores()
const { trackCTAClick } = await useTrackingEvents()
// const { logger } = await useLogging()

const selectedOption =
  searchOption.value.toLowerCase() === 'all' ? '' : searchOption.value
const appointmentOption = ref<string>(selectedOption)

const appointmentLink = computed(() => {
  const domain = $currentShop.value.appointmentDomain
  const baseFolder = $currentShop.value.appointmentDomainLocaleFolder

  if (!domain) {
    // logger.error(
    //   `Error: missing appointment domain for locale "${$currentShop.value.locale}" in store finder`,
    //   $currentShop,
    // )
    return '#'
  }

  const url = normalizeUrl([baseFolder, '/service'], domain)
  url.searchParams.set('branch-id', props.store.recordsetID)

  if (appointmentOption.value) {
    url.searchParams.set('product-category', appointmentOption.value)
  }

  return url.toString()
})

const appointmentType = computed(() => {
  return props.store.appointment_type ?? []
})

const onCTAClick = (event: any) => {
  trackCTAClick({
    element: event.target,
  })
}
</script>
